var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 158.8 184",
    viewBox: "0 0 158.8 184",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(354 351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-274.6-343.7c29.3 22.7 62.9 21.3 72.5 21.3-2.1 129.1-18.1 111.9-72.5 148.1-54.4-36.2-70.3-19-72.4-148.1 9.5 0 43 1.4 72.4-21.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-274.6-343.7 4.2-5.5c-2.5-1.9-6-1.9-8.5 0zm72.5 21.3 6.9.1c0-1.9-.7-3.6-2-5-1.3-1.3-3.1-2.1-4.9-2.1zm-72.5 148.1-3.8 5.8c2.3 1.5 5.3 1.5 7.7 0zm-72.4-148.1v-6.9c-1.9 0-3.6.7-4.9 2.1-1.3 1.3-2 3.1-2 5zm68.1-15.8c31.4 24.3 67.3 22.7 76.7 22.7v-13.8c-9.8 0-41.1 1.2-68.3-19.9zm69.8 15.7c-.5 32.1-1.9 54.8-4.5 71.6-2.6 16.6-6.2 26.6-11 33.6-4.8 7.3-10.8 11.6-19.7 16.9-9 5.4-20.3 11.2-34.3 20.4l7.7 11.5c13.3-8.8 24.3-14.5 33.7-20.1 9.5-5.7 17.8-11.9 24.1-21 6.3-9.4 10.5-21.6 13.2-39.2 2.7-17.4 4.1-41 4.6-73.5zm-61.7 142.4c-13.9-9.3-25.3-15.1-34.2-20.4s-14.9-9.6-19.7-16.9c-4.7-7-8.4-16.9-10.9-33.6-2.6-16.8-3.9-39.4-4.5-71.6l-13.9.3c.5 32.4 2 56 4.6 73.5 2.7 17.6 6.8 29.8 13.1 39.2 6.3 9.1 14.6 15.3 24 21 9.4 5.6 20.4 11.2 33.7 20.1zm-76.2-135.4c9.3 0 45.3 1.6 76.6-22.7l-8.4-11c-27.2 21.1-58.5 19.9-68.2 19.9z",
    fill: "#3375bb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/trust.bc8bdd78.svg";
export { ForwardRef as ReactComponent };